<template>
<div class="chapter">
<div class="inner_page">
<div id="fm7">
<p style="text-align: center;"><img alt="" class="figure" src="Book1/images/image_0001.jpg"/></p>
<p style="text-align: center;"><em class="italic">Kethan’s horoscope tarot reading</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// kethan.vue?1c05cdd8